<gtd-ui-field-default-protected [data]="data" [tmpl]="stringListTmlp"></gtd-ui-field-default-protected>
<ng-template #stringListTmlp>
  <p500-ui-many-items
    [data]="data"
    title="All IPs"
    i18n-title="@@common.all_ips"
    [tmpl]="tmpl"
    [previewTmpl]="previewTmpl"
  ></p500-ui-many-items>
  <ng-template let-data="data" #previewTmpl> {{ data }} </ng-template>
  <ng-template let-data="data" #tmpl>
    <span class="font-headline-5">
      {{ data }}
    </span>
  </ng-template>
</ng-template>
